import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import gr from '../../img/ProductsArvest/gr.svg'
import img from '../../img/ProductsArvest/img.png'

import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();

    return(
        <div className="relative bg-[#0B267E] max-w-[1920px] mx-auto pt-[60px] xl:pt-[100px] overflow-hidden">
            <div className="max-w-[1520px] mx-auto">
                <img src={img} className='absolute bottom-0 xl:left-1/2 xl:-translate-x-1/2' alt="" />
                <div className="max-w-[1220px] xl:mx-auto relative pt-[90px] pb-[250px] xl:pb-[180px]">
                    <Fade left><img src={gr} className='hidden xl:block absolute' alt="" /></Fade>
                    <Fade right><img src={gr} className='hidden xl:block absolute right-0 top-[200px]' alt="" /></Fade>
                    <img src={gr} className='absolute right-1/4 top-[350px] scale-[0.5] rotate-180' alt="" />                    
                    <div className="flex flex-col items-center">
                        <p className="text-center mx-[20px] xl:mx-0 open-sans spantext2 text-[#FFF] font-[700] text-[28px] xl:text-[45px]"><Trans>{t('productsarvest.1')}</Trans></p>
                        <p className="mt-[15px] mx-[20px] xl:mx-0 text-[17px] xl:text-[19px] font-[600] text-[#FFF] open-sans xl:max-w-[662px] text-center"><Trans>{t('productsarvest.2')}</Trans></p>
                        <Button color={'#EFEFEF'} text={'#0C2780'} className={'mt-[30px] xl:mt-[50px]'}/>             
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;